import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { GlobalState, Selection } from '@leverege/ui-redux';
import { Flex, Checkbox, Button } from '@leverege/ui-elements';
import { TableModel } from '@leverege/ui-attributes';
import { Plugins, Context } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import { ValueCache } from '@leverege/value-cache';
import S from './Shared.css';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.table.TableDataViewer');
const onClickCache = new ValueCache();
const selectColumn = (columns, {
  instance
}) => {
  const {
    context
  } = instance;
  const {
    clientProps: {
      model
    }
  } = context;
  const selectable = TableModel.getSelectable(model);
  const {
    clientProps: {
      targetKey,
      delegate
    }
  } = context;
  const defaultOnCheck = ({
    data,
    value
  }) => {
    const action = value ? 'add' : 'remove';
    GlobalState.dispatch(Selection[action](targetKey, data));
  };
  const defaultCheckAll = ({
    data,
    value
  }) => {
    const {
      page
    } = data;
    if (value) {
      GlobalState.dispatch(Selection.set(targetKey, page));
    } else {
      GlobalState.dispatch(Selection.clear(targetKey));
    }
  };
  const {
    onCheck = defaultOnCheck,
    onCheckAll = defaultCheckAll
  } = instance;
  const ret = [];
  const plgs = onClickCache.calc((objectType, path) => {
    const flt = Context.createMatch({
      objectType,
      path
    });
    const plgs = [...Plugins.get('tableDoubleClick', flt),
    // backwards compatibility
    ...Plugins.get('TableDataViewerDoubleClick', flt)];
    return plgs;
  }, delegate.relationship?.objectType, delegate.relationship?.path);
  if (delegate.isGotoAllowed() || plgs.length > 0) {
    ret.push({
      id: 'detail',
      disableFilters: true,
      disableSortBy: true,
      disableResizing: true,
      minWidth: 40,
      maxWidth: 40,
      width: 40,
      // Header : ( data ) => {
      //   const { targeted, data : page } = data
      //   const selectedCount = Selection.count( targeted )
      //   const length = ( page && page.length ) || 0
      //   const isSelected = selectedCount !== 0 && selectedCount === length

      //   return (
      //     <Checkbox
      //       variant="small"
      //       value={isSelected}
      //       eventData={{ targeted, page }}
      //       onChange={onCheckAll} />
      //   )
      // },
      Cell: ItemDetailCell
    });
  }
  if (selectable) {
    ret.push({
      id: 'targeted',
      disableFilters: true,
      disableSortBy: true,
      disableResizing: true,
      minWidth: 60,
      maxWidth: 60,
      width: 60,
      Header: data => {
        const {
          targeted,
          data: page
        } = data;
        const selectedCount = Selection.count(targeted);
        const length = page && page.length || 0;
        const isSelected = selectedCount !== 0 && selectedCount === length;
        return /*#__PURE__*/_jsx(Checkbox, {
          variant: "small",
          value: isSelected,
          eventData: {
            targeted,
            page
          },
          onChange: onCheckAll
        });
      },
      Cell: connect((state, ownProps) => {
        const targetKey = ownProps?.context?.clientProps?.targetKey;
        return {
          targeted: Selection.get(state, targetKey || 'targeted'),
          onCheck
        };
      })(ItemSelectCell)
    });
  }
  ret.push(...columns);
  return ret;
};
export default function useSelect(hooks) {
  hooks.allColumns.push(selectColumn);
  hooks.useInstanceBeforeDimensions.push(({
    headerGroups,
    context
  }) => {
    const {
      clientProps: {
        model
      }
    } = context;
    const selectable = TableModel.getSelectable(model);
    if (selectable) {
      // fix the parent group of the selection button to not be resizable
      const selectionGroupHeader = headerGroups[0].headers[0];
      selectionGroupHeader.canResize = false;
    }
  });
}
function ItemSelectCell(props) {
  const {
    row: {
      original
    },
    targeted,
    onCheck
  } = props;
  const value = Selection.isSelected(targeted, original.id);
  return /*#__PURE__*/_jsx(Flex, {
    style: {
      width: '100%'
    },
    justify: "center",
    align: "center",
    children: /*#__PURE__*/_jsx(Checkbox, {
      variant: "small",
      eventData: original,
      value: value,
      onChange: onCheck
    })
  });
}
function ItemDetailCell(props) {
  const {
    row,
    context
  } = props;
  const {
    clientProps: {
      delegate,
      relationship
    }
  } = context;
  const obj = row?.original;
  const goToDetail = useCallback(() => {
    if (delegate.isGotoAllowed()) {
      GlobalState.dispatch(delegate.goTo(obj?.id));
    } else {
      const flt = Context.createMatch({
        objectType: delegate.relationship?.objectType,
        path: delegate.relationship?.path
      });
      const plgs = [...Plugins.get('tableDoubleClick', flt),
      // backwards compatibility
      ...Plugins.get('TableDataViewerDoubleClick', flt)];
      for (let n = 0; n < plgs.length; n++) {
        const callReturn = plgs[n].onClick(obj, context);
        if (callReturn) {
          return;
        }
      }
    }
  }, [delegate, obj?.id]);
  return /*#__PURE__*/_jsx(Button, {
    className: S.detailButton,
    icon: tIcon('gotoItemIcon', 'fa-solid fa-arrow-up-right'),
    variant: "tableGotoLink|link",
    title: t('view', {
      blueprintName: relationship?.blueprint?.name
    }),
    onClick: goToDetail
  });
}